import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminLayout } from './components/admin/AdminLayout';
import { StandardIngredients } from './components/admin/StandardIngredients';
import { IngredientFormPage } from './components/admin/IngredientFormPage';
import { OrganizationsList } from './components/admin/OrganizationsList';
import { OrganizationAdmin } from './components/admin/OrganizationAdmin';
import { AdminOrganizationView } from './components/admin/AdminOrganizationView';
import { ReportsView } from './components/admin/ReportsView';
import { TikTokRecipeReader } from './components/admin/TikTokRecipeReader';
import { RecipeCreator } from './components/admin/RecipeCreator';
import { RecipeManagement } from './components/admin/RecipeManagement';
import { SocialImportReader } from './components/admin/SocialImportReader';
import { RetailerScraping } from './components/admin/RetailerScraping';
import { DataSyncPage } from './components/admin/data-sync/DataSyncPage';
import { CiqualNutritionPage } from './components/admin/nutrition/CiqualNutritionPage';
import { BulkMatchReviewPage } from './components/admin/nutrition/BulkMatchReviewPage';
import { UnitConversionPage } from './components/admin/unitConversion/UnitConversionPage';
import { UsdaBulkMatchReviewPage } from './components/admin/unitConversion/UsdaBulkMatchReviewPage';
import { MassDbPage } from './components/admin/mass-db/MassDbPage';
import { MassEnrichmentPage } from './components/admin/massEnrichment/MassEnrichmentPage';
import { MassEnrichmentReviewPage } from './components/admin/massEnrichment/MassEnrichmentReviewPage';

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/admin/ingredients" />} />

      <Route path="/admin" element={<AdminLayout />}>
        <Route path="ingredients/new" element={<IngredientFormPage />} />
        <Route path="ingredients/:id/edit" element={<IngredientFormPage />} />
        <Route path="ingredients" element={<StandardIngredients />} />
        <Route path="organizations" element={<OrganizationsList />} />
        <Route path="organizations/admin" element={<OrganizationAdmin />} />
        <Route path="organizations/:id" element={<AdminOrganizationView />} />
        <Route path="reports" element={<ReportsView />} />
        <Route path="recipes" element={<RecipeManagement />} />
        <Route path="tiktok" element={<TikTokRecipeReader />} />
        <Route path="recipe-creator" element={<RecipeCreator />} />
        <Route path="social-import" element={<SocialImportReader />} />
        <Route path="scraping" element={<RetailerScraping />} />

        <Route path="mass-db" element={<MassDbPage />}>
          <Route path="enrichment" element={<MassEnrichmentPage />} />
          <Route path="enrichment/review" element={<MassEnrichmentReviewPage />} />
          <Route path="sync" element={<DataSyncPage />} />
          <Route path="ciqual" element={<CiqualNutritionPage />} />
          <Route path="ciqual/match-review" element={<BulkMatchReviewPage />} />
          <Route path="conversion" element={<UnitConversionPage />} />
          <Route path="conversion/match-review" element={<UsdaBulkMatchReviewPage />} />
        </Route>

        {/* Legacy redirects */}
        <Route path="data-sync" element={<Navigate to="/admin/mass-db/sync" replace />} />
        <Route path="ciqual/match-review" element={<Navigate to="/admin/mass-db/ciqual/match-review" replace />} />
        <Route path="ciqual" element={<Navigate to="/admin/mass-db/ciqual" replace />} />
        <Route
          path="unit-conversion/match-review"
          element={<Navigate to="/admin/mass-db/conversion/match-review" replace />}
        />
        <Route path="unit-conversion" element={<Navigate to="/admin/mass-db/conversion" replace />} />
      </Route>

      <Route path="*" element={<Navigate to="/admin/ingredients" />} />
    </Routes>
  );
}
